(function ($) {
  // Quickshop options used for grid tile.
  var quickshopOptions = {
    variables: {
      qs_class: 'grid-tile__quickshop js-grid-tile__quickshop'
    },
    productDataOptions: {
      forceSingleSku: true
    }
  };
  /*
   * Check containers for lazyload objects. This should be coupled with a load
   * event hook to recheck on img load.
   */
  var checkLazyLoad = function (lazyloadContainers) {
    $(lazyloadContainers).each(function (i, obj) {
      var $lazyloadContainer = $(obj);

      if ($lazyloadContainer.hasClass('lazyload-complete')) {
        return;
      }
      var $lazyImages = $('.lazyload', $lazyloadContainer);

      if ($lazyImages.length === 0) {
        $lazyloadContainer.addClass('lazyload-complete');
        $lazyloadContainer.trigger('lazyload-complete');
      }
    });
  };
  /*
   * Quick util to remove lazy callbacks
   */
  var removeWhenLazy = function ($lazyloadContainers) {
    $lazyloadContainers.off('.runWhen');
  };
  /*
   * Util function that will only run when the target container has no more
   * lazyload objects.
   */
  var runWhenLazyloadComplete = function ($lazyloadContainer, callback) {
    removeWhenLazy($lazyloadContainer);
    if ($lazyloadContainer.hasClass('lazyload-complete')) {
      callback();

      return;
    }
    $lazyloadContainer.on('lazyload-complete.runWhen', function (e) {
      removeWhenLazy($lazyloadContainer);
      callback();
    });
  };

  Drupal.behaviors.gridTileV1 = {
    attach: function (context, settings) {
      var $tiles = $('.js-grid-tile', context);

      $tiles.each(function (i, obj) {
        var $tile = $(obj);
        var ctaMode = $tile.data('cta-mode');
        var $images = $('.js-grid-tile__image', $tile);

        // Have images set a lazyload complete flag
        $images.each(function (i, obj) {
          obj.addEventListener(
            'load',
            function (e) {
              checkLazyLoad(obj);
            },
            true
          );
        });
        // run initial check;
        checkLazyLoad($images);

        // Quickshop Button link
        var $quickshopButton = $('.js-quickshop-launch-button', $tile);

        $quickshopButton.on('click', function (e) {
          // select defaultSku
          var skuBaseId = null;

          if ($tile.data('sku-base-id')) {
            skuBaseId = $tile.data('sku-base-id');
          }
          $tile.trigger('product.quickshop.launch.inline', [skuBaseId, quickshopOptions]);

          // Trigger 'product.init' to set product status
          $('.js-product', '.js-quickshop').trigger('product:init');
        });

        // Shadename Link.
        var $productLink = $('.js-shadename-link', $tile);

        $productLink.on('click', function (e) {
          // If we are in add_to_bag mode and have a valid add to cart button.
          // Then the button and then exit.
          if (ctaMode === 'add_to_bag') {
            var $addToBag = $('.js-add-to-cart:not(.hidden)', $tile);

            if ($addToBag.length > 0) {
              $addToBag.trigger('click');
            }
            e.preventDefault();

            return;
          }

          // quickshop logic.
          e.preventDefault();
          // select defaultSku
          var skuBaseId = null;

          if ($tile.data('sku-base-id')) {
            skuBaseId = $tile.data('sku-base-id');
          }
          $tile.trigger('product.quickshop.launch.inline', [skuBaseId, quickshopOptions]);

          // Trigger 'product.init' to set product status
          $('.js-product', '.js-quickshop').trigger('product:init');
        });
      });

      /*
       * Respond to stateFlag changes. If we have an image that matches a
       * stateFlag, switch to that image.
       */
      $tiles.on('set-state-flags', function (e, state) {
        var $tile = $(this);
        var imageTagConfig = $tile.data('image-tags');

        // If state is empty. Turn off state sentinel class.
        if (state._empty) {
          $tile.removeClass('grid-tile--has-state');
        } else {
          $tile.addClass('grid-tile--has-state');
        }

        // set filtered class
        if (state.filtered) {
          $tile.addClass('grid-tile--filtered');
        } else {
          $tile.removeClass('grid-tile--filtered');
        }

        for (var key in state) {
          if (key in imageTagConfig) {
            $tile.triggerHandler('grid-tile:set-image-tag', key);

            return;
          }
        }
        $tile.triggerHandler('grid-tile:set-image-tag', 'default');
      });

      /*
       * Switch the image out for another state image.
       */
      $tiles.on('grid-tile:set-image-tag', function (e, imageTag) {
        var $tile = $(this);

        $tile.data('image-tag', imageTag);
        $tile.triggerHandler('grid-tile:set-default-image-to-tag', [imageTag]);
      });

      /*
       * This image change handler uses multiple image elements and flips them
       * on. This allows for animation effects like card flipping or fade.
       */
      $tiles.on('grid-tile:set-image-tag-animation', function (e, imageTag) {
        var $tile = $(this);
        var imageTagConfig = $tile.data('image-tags');

        if (!(imageTag in imageTagConfig)) {
          return;
        }

        var $images = $('.js-grid-tile__image', $tile);
        var $inactiveImages = $images.filter(':not([data-image-tag="' + imageTag + '"])');
        var $stateImage = $images.filter('[data-image-tag="' + imageTag + '"]');

        // Remove current callbacks so we don't clash removing actives
        removeWhenLazy($images);
        runWhenLazyloadComplete($stateImage, function () {
          // only hide when target image has lazyloaded
          $inactiveImages.removeClass('active');
        });
        $stateImage.addClass('active');
      });

      /*
       * Change default image
       *
       * This handler can be used to change the default image. It can also be
       * used to do the state change by changing the default image source.
       *
       * isDefault is to track requests that are meant to change the default
       * state image and not just apply a state change.
       */
      // eslint-disable-next-line complexity
      $tiles.on('grid-tile:set-default-image-to-tag', function (e, imageTag, isDefault) {
        var $tile = $(this);
        var currentImageTag = $tile.data('image-tag');

        if (isDefault && currentImageTag !== 'default') {
          return;
        }
        var imageConfig = $tile.data('image-tags');
        var $defaultImage = $('.js-grid-tile__image[data-image-tag="default"] img', $tile);
        var $defaultSource = $('.js-grid-tile__image[data-image-tag="default"] source', $tile);
        var newImage = null;

        if (imageTag in imageConfig) {
          newImage = imageConfig[imageTag];
        }

        /*
         * If new image is different the currently shown image. Change the
         * default image out. Note this is changing the default image and not a
         * state image.
         */
        if (newImage && $defaultImage.attr('data-src') !== newImage) {
          $defaultSource.attr('data-srcset', newImage);
          $defaultImage.attr('data-src', newImage);
          // if we alredy lazy loaded. set the src
          if (!$defaultImage.hasClass('lazyload')) {
            $defaultSource.attr('srcset', newImage);
            $defaultImage.attr('src', newImage);
          }
        }
      });
    }
  };
})(jQuery);
